import script from "./CrowdfundingLive.vue?vue&type=script&setup=true&lang=js"
export * from "./CrowdfundingLive.vue?vue&type=script&setup=true&lang=js"

import "./CrowdfundingLive.vue?vue&type=style&index=0&id=c24ac5a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c24ac5a2"]])

export default __exports__